






import Vue from "vue";

interface Props {
  crumbs: string[];
}

export default Vue.extend<Props>({
  name: "TtBreadCrumbNav",
  functional: true,

  props: {
    crumbs: { type: Array as () => string[], required: true }
  }
});
